export default __webpack_public_path__ + "static/media/1v1_silver_bg.d35b5cc2.png";